<template>
  <div class="game-view">
    <span v-if="match && match.board" class="tag is-info is-small mb-1">
      Board {{ match.board }}
    </span>

    <div class="game-view__board">
      <GameBoard :view-threats="viewThreats" :view-only="true">
        <GameDataManagerFirebase :matchId="gameId" />
      </GameBoard>
    </div>
  </div>
</template>

<script>
import GameBoard from "@/components/games/compact/GameBoard";
import GameDataManagerFirebase from "@/components/games/GameDataManagerFirebase";
import { mapGetters } from "vuex";

export default {
  name: "GameViewV2",

  props: ["gameId", "viewThreats"],

  components: {
    GameBoard,
    GameDataManagerFirebase,
  },

  computed: {
    ...mapGetters({
      getGameDataCopyByMatchId: "getGameDataCopyByMatchId",
    }),

    gameDataCopy() {
      return this.getGameDataCopyByMatchId(this.gameId);
    },

    match() {
      return this.gameDataCopy.match;
    },
  },
};
</script>

<style scoped>
.game-view__board /deep/ .gameboard__chessboard {
  width: 320px;
  height: 320px;
}
</style>
